module.exports = __webpack_public_path__ + "media/thumbnails/headgear-style-2-b971997e.svg";